import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Header, Icon, Button, Tab, Loader } from "semantic-ui-react";
import { ListStudent } from "../../../components/Admin/AcademicManagement";
import { useAuth } from "../../../hooks";
import { Grade, AcademicCycle } from "../../../api";

const gradeController = new Grade();
const academicCycleController = new AcademicCycle();


export function AcademicManagement() {
  const [reload, setReload] = useState(false);
  const [academicCycle, setAcademicCycle] = useState(null);
  const { accessToken } = useAuth();
  const { academicCycleId } = useParams();
  const [grades, setGrades] = useState([]);

  const onReload = () => setReload((prevState) => !prevState);

  useEffect(() => {
    (async () => {
      try {
        const response = await academicCycleController.getAcademicCycle(
          academicCycleId
        );
        setAcademicCycle(response);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [academicCycleId, accessToken]);

  /* useEffect(() => {
    (async () => {
      try {
        setGrades([]);
        const response = await gradeController.getGrades(accessToken);
        setGrades(response);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [academicCycleId, accessToken]); */

  useEffect(() => {
      if (!academicCycle) return;
      (async () => {
        try {
          setGrades([]);
          const response = await gradeController.getGradesByLevelId(
            academicCycle.levelId,
            accessToken
          );
          setGrades(response);
        } catch (error) {
          console.error(error);
        }
      })();
    }, [academicCycle, accessToken]);

  const panes = [];

  for (const grade of grades) {
    panes.push({
      menuItem: grade.name,
      render: () => (
        <Tab.Pane as="div" attached={false}>
          <ListStudent
            gradeId={grade.id}
            academicCycle={academicCycle}
            reload={reload}
            onReload={onReload}
          />
        </Tab.Pane>
      ),
    });
  }

  if (!academicCycle) return <Loader active inline="centered" />;

  return (
    <>
      <div className="student-page">
        <Header as="h3">
          <Icon name="users" />
          <Header.Content>
            Estudiantes matriculados en Año académico {academicCycle.name} - {academicCycle.Level?.name}
          </Header.Content>
        </Header>
        <Tab className="student-page__filters" menu={{ secondary: true }} panes={panes} />
      </div>
    </>
  );
}
